import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-department-community-hall-module',
  templateUrl: './department-community-hall-module.component.html',
  styleUrls: ['./department-community-hall-module.component.css']
})
export class DepartmentCommunityHallModuleComponent {
  bookPolicy:boolean = false;
  verOfSoc:boolean = false;
  socDeb=false;
  home:boolean=true;
  

  constructor(private fb: FormBuilder) {}
  ngOnInit(): void {
   this.home=true;
  }
  bookPolicyFun(){
  this.bookPolicy = true;
  this.verOfSoc = false;
  this.socDeb=false;
  this.home=false;
 
  }
  verOfSocFun(){
    this.bookPolicy = false;
    this.verOfSoc = true;
    this.socDeb=false;
    this.home=false;
  }
  socDebFun(){
    this.bookPolicy = false;
    this.verOfSoc = false;
    this.socDeb=true;
    this.home=false;
  }
 

  onSubmit() {
    alert('Thanks!');
  }
}
